import { store } from "@/store.js";
const fb = require("@/firebaseConfig.js");

class CalendarPlugin {
  constructor() {
    this.userData = null;
    this.butezDocPath = store.state.calendarButezPath;
    this.cityType = null;
    this.butezCollectionPath = null;
    this._initialized = false;

    // Special dates to inject into calendar (e.g., February 28th)
    this.allowedSpecialDates = [`${store.state.kSchoolStartYear + 1}-02-28`];
  }

  // Initialize the calendar with user data
  init(userData) {
    this.userData = userData;

    if (
      userData &&
      userData.school &&
      userData.school.id == "tAhypAsCOSqWLMjFNfUH"
    ) {
      this.butezCollectionPath = "dateData-niislel";
      this.cityType = "tAhypAsCOSqWLMjFNfUH";
    } else if (
      userData &&
      userData.school &&
      userData.school.cityCode == "01"
    ) {
      this.butezCollectionPath = "dateData-niislel";
      this.cityType = "niislel";
    } else {
      this.butezCollectionPath = "dateData-aimag";
      this.cityType = "aimag";
    }

    this._initialized = true;
  }

  // Parse a value into a Date anchored in LOCAL time.
  // Bare "YYYY-MM-DD" strings are parsed as local midnight (not UTC) so the
  // calendar day never shifts by one depending on the browser timezone.
  _toLocalDate(value) {
    if (!value) return null;
    if (value instanceof Date) return new Date(value.getTime());
    if (typeof value.toDate === "function") return value.toDate();
    if (typeof value === "string") {
      const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) {
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      }
    }
    return new Date(value);
  }

  // Calculate week number for academic year
  calculateWeekNumber(date) {
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();

    let academicYearStart;
    if (currentMonth < 8) {
      academicYearStart = new Date(currentYear - 1, 8, 1);
    } else {
      academicYearStart = new Date(currentYear, 8, 1);
    }

    const diffTime = date.getTime() - academicYearStart.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    const weekNumber = Math.floor(diffDays / 7) + 1;
    return weekNumber > 0 ? weekNumber : 1;
  }

  // Get current week number
  getCurrentWeekNumber() {
    var date = null;
    var currentWeek = this.calculateWeekNumber(new Date());

    while (!date) {
      try {
        date = store.state._kCalendarButez.find(
          (d) => d.weekNumber == currentWeek,
        );
        if (!date) currentWeek--;
      } catch (error) {
        break;
      }
    }
    if (date) {
      return currentWeek;
    }
    return null;
  }

  // Generate calendar data
  async generateCalendarData(calendarRestrictions) {
    const weekDays = [
      "Даваа",
      "Мягмар",
      "Лхагва",
      "Пүрэв",
      "Баасан",
      "Бямба",
      "Ням",
    ];

    var calendar = [];
    const dayIntervalMS = 24 * 60 * 60 * 1000; //1 day
    // console.log(
    //   "[calendar-plugin] Generating calendar data for cityType:",
    //   this.cityType,
    //   calendarRestrictions,
    // );
    const semesters = calendarRestrictions["session-" + this.cityType];

    semesters.forEach((semester) => {
      if (
        store?.state?.userData?.school?.id == "tAhypAsCOSqWLMjFNfUH" &&
        semester.value == 2
      ) {
        var startDate = new Date(
          this._toLocalDate(semester.startDate).getFullYear(),
          0,
          12,
        );
      } else {
        startDate = this._toLocalDate(semester.startDate);
      }
      const endDate = this._toLocalDate(semester.endDate);

      startDate.setHours(12, 0, 0, 0);
      endDate.setHours(12, 0, 0, 0);

      let date = startDate.getTime(); // ms timestamp

      while (date <= endDate.getTime()) {
        const dateString = this.formatDateToString(new Date(date));
        const weekNumber = this.calculateWeekNumber(new Date(date));
        const garag =
          new Date(date).getDay() == 0 ? 7 : new Date(date).getDay();
        const garagName = weekDays[garag - 1];
        const year = new Date(date).getFullYear();
        const month = new Date(date).getMonth() + 1;
        const day = new Date(date).getDate();
        const dayInfo = calendarRestrictions.dateData.filter(
          (d) => d.dateString == dateString,
        );
        const calDataString = `${semester.value}-1-${garag}`;

        var calObject = {
          calDataString: calDataString,
          date: dateString,
          dateObject: new Date(date),
          weekNumber: weekNumber,
          garag: garag,
          garagName: garagName,
          year: year,
          month: month,
          day: day,
          semester: semester.value,
          isHoliday: false,
        };

        if (dayInfo && dayInfo.length > 0) {
          dayInfo.forEach((di) => {
            calObject[di.calType] = true;
            calObject[di.calType + "-object"] = di["calTypeObject"];
            calObject[di.calType + "-academicLevel"] = [
              ...(calObject[di.calType + "-academicLevel"] ?? []),
              ...di["gradeInfo"]["levels"],
            ];
          });
        }

        if (garag < 6) {
          calendar.push(calObject);
        }

        date += dayIntervalMS;
      }
    });
    return calendar;
  }

  // Get calendar restrictions from Firebase
  async getFirebaseRestrictions() {
    if (!this._initialized) {
      throw new Error(
        "Calendar plugin not initialized. Call $calendar.init(userData) first.",
      );
    }

    const calendarButez = await fb.db
      .doc(this.butezDocPath)
      .get()
      .then((doc) => {
        return {
          ...doc.data(),
          id: doc.id,
          ref: doc.ref,
        };
      });

    const schoolId = this.userData?.school?.id;

    // Parallel load: global dateData and school-specific dateData
    const [globalDateData, schoolDateData] = await Promise.all([
      // 1. Load global dateData from cityType collection
      calendarButez.ref
        .collection(this.butezCollectionPath)
        .get()
        .then((docs) => {
          return docs.docs.map((doc) => {
            return {
              ...doc.data(),
              id: doc.id,
              ref: doc.ref,
              isGlobal: true,
            };
          });
        }),

      // 2. Load school-specific dateData (if school exists)
      schoolId
        ? calendarButez.ref
            .collection("dateData-" + schoolId)
            .get()
            .then((docs) => {
              return docs.docs.map((doc) => {
                return {
                  ...doc.data(),
                  id: doc.id,
                  ref: doc.ref,
                  isSchoolSpecific: true,
                  schoolId: schoolId,
                };
              });
            })
        : Promise.resolve([]),
    ]);

    console.log(
      "[calendar-plugin] Loaded global entries:",
      globalDateData.length,
      "school entries:",
      schoolDateData.length,
    );

    // 3. Filter out global entries that should be skipped for current school
    const filteredGlobalData = globalDateData.filter((entry) => {
      if (
        schoolId &&
        entry.skipForSchoolIds &&
        Array.isArray(entry.skipForSchoolIds)
      ) {
        if (entry.skipForSchoolIds.includes(schoolId)) {
          console.log(
            "[calendar-plugin] Skipping global entry for school:",
            entry.id,
          );
          return false;
        }
      }
      return true;
    });

    // 4. Merge: school data overrides global data for same keys (id)
    const mergedDataMap = new Map();

    // Add global data first
    filteredGlobalData.forEach((entry) => {
      mergedDataMap.set(entry.id, entry);
    });

    // Override with school-specific data
    schoolDateData.forEach((entry) => {
      mergedDataMap.set(entry.id, entry);
    });

    calendarButez.dateData = Array.from(mergedDataMap.values());

    console.log(
      "[calendar-plugin] Total merged entries:",
      calendarButez.dateData.length,
    );

    const semesters = calendarButez["session-" + this.cityType];
    store.set("_kSemesters", semesters);

    return calendarButez;
  }

  // Inject special dates into calendar data
  injectSpecialDates(calendarButez, calendarRestrictions) {
    const weekDays = [
      "Даваа",
      "Мягмар",
      "Лхагва",
      "Пүрэв",
      "Баасан",
      "Бямба",
      "Ням",
    ];

    const existingDates = new Set(calendarButez.map((d) => d.date));
    const semesters = calendarRestrictions["session-" + this.cityType];

    this.allowedSpecialDates.forEach((dateString) => {
      // Skip if already exists in calendar
      if (existingDates.has(dateString)) return;

      const date = this._toLocalDate(dateString);
      date.setHours(12, 0, 0, 0);

      const weekNumber = this.calculateWeekNumber(date);
      const garag = date.getDay() == 0 ? 7 : date.getDay();
      const garagName = weekDays[garag - 1];
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      // Determine semester based on date
      let semester = null;
      for (const sem of semesters) {
        const startDate = this._toLocalDate(sem.startDate);
        const endDate = this._toLocalDate(sem.endDate);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        if (date >= startDate && date <= endDate) {
          semester = sem.value;
          break;
        }
      }

      // If not within any semester, use closest semester
      if (!semester && semesters.length > 0) {
        semester = semesters[semesters.length - 1].value;
      }

      const calDataString = `${semester}-1-${garag}`;
      const dayInfo = calendarRestrictions.dateData.filter(
        (d) => d.dateString == dateString,
      );

      var calObject = {
        calDataString: calDataString,
        date: dateString,
        dateObject: date,
        weekNumber: weekNumber,
        garag: garag,
        garagName: garagName,
        year: year,
        month: month,
        day: day,
        semester: semester,
        isHoliday: false,
        isSpecialDate: true,
      };

      if (dayInfo && dayInfo.length > 0) {
        dayInfo.forEach((di) => {
          calObject[di.calType] = true;
          calObject[di.calType + "-object"] = di["calTypeObject"];
          calObject[di.calType + "-academicLevel"] = [
            ...(calObject[di.calType + "-academicLevel"] ?? []),
            ...di["gradeInfo"]["levels"],
          ];
        });
      }

      calendarButez.push(calObject);
      console.log("[calendar-plugin] Injected special date:", dateString);
    });

    // Sort by date after injection
    calendarButez.sort((a, b) => new Date(a.date) - new Date(b.date));

    return calendarButez;
  }

  // Main function to load calendar data
  async loadCalendar() {
    if (!this._initialized) {
      throw new Error(
        "Calendar plugin not initialized. Call $calendar.init(userData) first.",
      );
    }

    try {
      var calendarRestrictions = await this.getFirebaseRestrictions();
      var calendarButez = await this.generateCalendarData(calendarRestrictions);

      // Inject special dates (e.g., February 28th)
      calendarButez = this.injectSpecialDates(
        calendarButez,
        calendarRestrictions,
      );

      store.set("_kCalendarButez", calendarButez);
      return calendarButez;
    } catch (error) {
      console.error("Error loading calendar:", error);
      throw error;
    }
  }

  // Utility functions
  getWeekNumber(date) {
    return this.calculateWeekNumber(date);
  }

  // Format date to string
  formatDateToString(date) {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Get day name in Mongolian
  getDayName(dayNumber) {
    const weekDays = [
      "Даваа",
      "Мягмар",
      "Лхагва",
      "Пүрэв",
      "Баасан",
      "Бямба",
      "Ням",
    ];
    return weekDays[dayNumber - 1] || "";
  }

  getCalendarObject(year, month, day) {
    const calendarData = store.state._kCalendarButez || [];
    return calendarData.find(
      (d) => d.year === year && d.month === month && d.day === day,
    );
  }

  // Check if date is holiday
  isHoliday(dateString) {
    const calendarData = store.state._kCalendarButez || [];
    const dateInfo = calendarData.find((d) => d.date === dateString);
    return dateInfo ? dateInfo.isHoliday : false;
  }

  // Get semester for date
  getSemesterForDate(dateString) {
    const calendarData = store.state._kCalendarButez || [];
    const dateInfo = calendarData.find((d) => d.date === dateString);
    return dateInfo ? dateInfo.semester : null;
  }

  // Get week number for date
  getWeekNumberForDate(dateString) {
    const calendarData = store.state._kCalendarButez || [];
    const dateInfo = calendarData.find((d) => d.date === dateString);
    return dateInfo ? dateInfo.weekNumber : null;
  }

  // Get all dates for a specific week
  getDatesForWeek(weekNumber) {
    const calendarData = store.state._kCalendarButez || [];
    return calendarData.filter((d) => d.weekNumber === weekNumber);
  }

  // Get total holiday days
  getTotalHolidayDays() {
    const calendarData = store.state._kCalendarButez || [];
    return calendarData.filter((d) => d.isHoliday).length;
  }

  // Get all dates for a specific month
  getDatesForMonth(month) {
    const calendarData = store.state._kCalendarButez || [];
    return calendarData.filter((d) => d.month === month);
  }

  // Get all dates for a specific semester
  getDatesForSemester(semesterValue) {
    const calendarData = store.state._kCalendarButez || [];
    return calendarData.filter((d) => d.semester === semesterValue);
  }

  // Get all weekNumbers for a specific semester
  getWeeksForSemester(semesterValue) {
    const calendarData = store.state._kCalendarButez || [];
    const weeksSet = new Set();

    calendarData.forEach((d) => {
      if (d.semester === semesterValue) {
        weeksSet.add(d.weekNumber);
      }
    });

    return Array.from(weeksSet);
  }

  // Get all months for a specific semester
  getMonthsForSemester(semesterValue) {
    const calendarData = store.state._kCalendarButez || [];
    const monthsSet = new Set();
    calendarData.forEach((d) => {
      if (d.semester === semesterValue) {
        monthsSet.add(d.month + "-" + d.year);
      }
    });
    return Array.from(monthsSet).map((m) => {
      const [month, year] = m.split("-");
      return { month: parseInt(month), year: parseInt(year) };
    });
  }

  // Get all months for a specific year
  getMonthsForYear(year) {
    const calendarData = store.state._kCalendarButez || [];
    const monthsSet = new Set();
    calendarData.forEach((d) => {
      if (d.year === year) {
        monthsSet.add(d.month);
      }
    });
    return Array.from(monthsSet).map((m) => {
      return { month: m, year: year };
    });
  }

  // Get current semester
  getCurrentSemester() {
    const today = this.formatDateToString(new Date());
    return this.getSemesterForDate(today);
  }

  // Get semesters from store
  getSemesters() {
    return store.state._kSemesters || [];
  }

  // Get semester numbers only, e.g. [1, 2, 3]. Falls back to [1, 2, 3]
  // when the calendar structure is not loaded yet.
  getSemesterNumbers() {
    const semesters = store.state._kSemesters || [];
    if (!semesters.length) return [1, 2, 3];
    return semesters.map((s) => s.value);
  }

  // Get calendar data from store
  getCalendarData() {
    return store.state._kCalendarButez || [];
  }

  isCalType(dateString, ACADEMIC_LEVEL) {
    const academicLevel = Number(ACADEMIC_LEVEL);
    const calendarData = store.state._kCalendarButez || [];

    const dateInfo = calendarData.find((d) => d.date === dateString);
    if (!dateInfo) return [];

    const calTypes = Object.keys(dateInfo)
      .filter((key) => key.endsWith("-academicLevel"))
      .map((key) => key.replace("-academicLevel", ""));

    var applyingCalTypes = [];
    for (const calType of calTypes) {
      const levels = dateInfo[calType + "-academicLevel"];
      if (Array.isArray(levels) && levels.includes(academicLevel)) {
        applyingCalTypes.push(calType);
      }
    }

    return applyingCalTypes;
  }
}

// Create calendar instance
const calendar = new CalendarPlugin();

// Vue plugin definition
const CalendarVuePlugin = {
  install(Vue) {
    // Add $calendar to Vue prototype
    Vue.prototype.$calendar = calendar;

    // Add global property
    Vue.$calendar = calendar;
  },
};

export default CalendarVuePlugin;
export { calendar };
